import { useQuery, UseQueryOptions } from 'react-query';

import {
  getContactsCount,
  GetContactsCountResponse,
} from '@app/store/transport-layer/document/address-book/contacts/count';

const useContactsCount = (
  options?: UseQueryOptions<GetContactsCountResponse, Error, GetContactsCountResponse>
) => {
  return useQuery<GetContactsCountResponse, Error, GetContactsCountResponse>({
    queryKey: ['address-book-contacts-count'],
    queryFn: () => getContactsCount(),
    ...options,
  });
};

export default useContactsCount;
